import { atom } from "recoil";
export const ProfileModalState = atom({
    key: "ProfileModalState", // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});
